// ✅ Step 1: Update `bundle-add.js`
// This version ensures drawer compatibility and prevents mass deletion bugs

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bundle-add-btn').forEach(button => {
    button.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          console.error('Failed to add to cart:', await response.text());
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
      }
    });
  });

  // Optional: Attach remove item functionality using line item keys
  document.querySelectorAll('.remove-item').forEach(button => {
    button.addEventListener('click', async () => {
      const key = button.dataset.lineItemKey;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });

        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          console.error('Remove failed:', await res.text());
        }
      } catch (err) {
        console.error('Remove error:', err);
      }
    });
  });
});
